export default __webpack_public_path__ + "static/media/WNo.6-3.ea0e864d.jpg";